import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import IconRowWithArrow from "../../../components/shared/IconRowWithArrow";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function ProfileSupportPage() {
  const navigate = useNavigate();
  const { config } = useSelector((state) => state.config);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            پشتیبانی
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto", display: "block" }}>
        {[
          {
            title: "پشتیبانی آنلاین",
            action: () => {
              window.open(config.onlineSupportUrl);
            },
          },
          {
            title: "سوالات متداول",
            action: () => {
              window.open(process.env.REACT_APP_FAQ_URL);
            },
          },
        ].map((item) => {
          return (
            <IconRowWithArrow
              sx={{ mb: "24px" }}
              key={item.title}
              title={item.title}
              onClick={item.action}
            />
          );
        })}
      </PageContentContainer>
    </>
  );
}

export default ProfileSupportPage;
